import React from 'react'
import * as Component from 'components/Loaders/allLoaders'

const Loader = ({ loader, ...rest }) => {
  const MyLoader = Component[loader]
  return <MyLoader {...rest} />
}

export default Loader
